
import { isNumber, isLetter, isChinese, isEmail, isPhone, isUnlimited, isHttp, isIDNO } from '@/util/checkValue/check.js';

export const Check = (info, ques) => {
    console.log('info, ques :>> ', info, ques);
    // console.log('验证格式', info);
    let result = false;
    console.log('info.format :>> ', info.format);
    switch (info.format) {
        case 0:
            if (isUnlimited(info.userAnswer) != true) {
                if (ques) {
                    ques.validateMsg = isUnlimited(info.userAnswer);
                    ques.validate = true;
                }
                info.validateMsg = isUnlimited(info.userAnswer);
                info.validate = true;
                return (result = true);
            } else {
                if (ques) {
                    ques.validate = false;
                }
                info.validate = false;
            }
            break;

        case 1:
            if (isNumber(info.userAnswer) != true) {
                if (ques) {
                    ques.validateMsg = isNumber(info.userAnswer);
                    ques.validate = true;
                }
                info.validateMsg = isNumber(info.userAnswer);
                info.validate = true;
                return (result = true);
            } else {
                if (ques) {
                    ques.validate = false;
                }
                info.validate = false;
            }
            break;
        case 2:
            if (isLetter(info.userAnswer) != true) {
                if (ques) {
                    ques.validateMsg = isLetter(info.userAnswer);
                    ques.validate = true;
                }
                info.validateMsg = isLetter(info.userAnswer);
                info.validate = true;
                return (result = true);
            } else {
                if (ques) {
                    ques.validate = false;
                }
                info.validate = false;
            }
            break;
        case 3:
            if (isChinese(info.userAnswer) != true) {
                if (ques) {
                    ques.validateMsg = isChinese(info.userAnswer);
                    ques.validate = true;
                }
                info.validateMsg = isChinese(info.userAnswer);
                info.validate = true;
                return (result = true);
            } else {
                if (ques) {
                    ques.validate = false;
                }
                info.validate = false;
            }
            break;
        case 4:
            if (isEmail(info.userAnswer) != true) {
                if (ques) {
                    ques.validateMsg = isEmail(info.userAnswer);
                    ques.validate = true;
                }
                info.validateMsg = isEmail(info.userAnswer);
                info.validate = true;
                return (result = true);
            } else {
                if (ques) {
                    ques.validate = false;
                }
                info.validate = false;
            }
            break;
        case 5:
            console.log('isPhone(info.userAnswer) :>> ', isPhone(info.userAnswer));
            if (isPhone(info.userAnswer) != true) {
                if (ques) {
                    ques.validateMsg = isPhone(info.userAnswer);
                    ques.validate = true;
                }
                info.validateMsg = isPhone(info.userAnswer);
                info.validate = true;
                return (result = true);
            } else {
                if (ques) {
                    ques.validate = false;
                }
                info.validate = false;
            }
            break;
        case 6:
            if (isHttp(info.userAnswer) != true) {
                if (ques) {
                    ques.validateMsg = isHttp(info.userAnswer);
                    ques.validate = true;
                }
                info.validateMsg = isHttp(info.userAnswer);
                info.validate = true;
                return (result = true);
            } else {
                if (ques) {
                    ques.validate = false;
                }
                info.validate = false;
            }
            break;
        case 7:
            if (isIDNO(info.userAnswer) != true) {
                if (ques) {
                    ques.validateMsg = isIDNO(info.userAnswer);
                    ques.validate = true;
                }
                info.validateMsg = isIDNO(info.userAnswer);
                info.validate = true;
                return (result = true);
            } else {
                if (ques) {
                    ques.validate = false;
                }
                info.validate = false;
            }
            break;
    }
    if (info.format == 0
        || info.format == 2
        || info.format == 3
        || info.format == 4
    ) {
        info.minNum = info.minNum || 0;
        info.maxNum = info.maxNum || 0;
        if ((parseFloat(info.minNum) != 0 && parseFloat(info.minNum) > info.userAnswer.length) || (parseFloat(info.maxNum) != 0 && parseFloat(info.maxNum) < info.userAnswer.length)) {
            if (parseFloat(info.minNum) == 0) {
                if (ques) ques.validateMsg = `输入字数最大长度为${parseFloat(info.maxNum)}`;
                info.validateMsg = `输入字数最大长度为${parseFloat(info.maxNum)}`;
            } else if (parseFloat(info.maxNum) == 0) {
                if (ques) ques.validateMsg = `输入字数最小长度为${parseFloat(info.minNum)}`;
                info.validateMsg = `输入字数最小长度为${parseFloat(info.minNum)}`;
            } else {
                if (ques) ques.validateMsg = `输入字数长度范围在${parseFloat(info.minNum)}~${parseFloat(info.maxNum)}之间`;
                info.validateMsg = `输入字数长度范围在${parseFloat(info.minNum)}~${parseFloat(info.maxNum)}之间`;
            }
            if (ques) ques.validate = true;
            info.validate = true;
            return (result = true);
        }
    } else if (info.format == 1) {
        if ((parseFloat(info.minNum) != 0 && parseFloat(info.minNum) > parseFloat(info.userAnswer)) || (parseFloat(info.maxNum) != 0 && parseFloat(info.maxNum) < parseFloat(info.userAnswer))) {
            if (parseFloat(info.minNum) == 0 || !parseFloat(info.minNum)) {
                if (ques) ques.validateMsg = `数字最大为${parseFloat(info.maxNum)}`;
                info.validateMsg = `数字最大为${parseFloat(info.maxNum)}`;
            } else if (parseFloat(info.maxNum) == 0 || !parseFloat(info.maxNum)) {
                if (ques) ques.validateMsg = `数字最小为${parseFloat(info.minNum)}`;
                info.validateMsg = `数字最小为${parseFloat(info.minNum)}`;
            } else {
                if (ques) ques.validateMsg = `数字大小范围在${parseFloat(info.minNum)}~${parseFloat(info.maxNum)}之间`;
                info.validateMsg = `数字大小范围在${parseFloat(info.minNum)}~${parseFloat(info.maxNum)}之间`;
            }
            if (ques) ques.validate = true;
            info.validate = true;
            return (result = true);
        }
        if (countDecimalPlaces(info.userAnswer) > info.decimalPlaces) {
            if (info.decimalPlaces == 0) {
                if (ques) ques.validateMsg = `不支持保留小数`;
                info.validateMsg = `不支持保留小数`;
            } else {
                if (ques) ques.validateMsg = `仅支持保留${info.decimalPlaces}位小数`;
                info.validateMsg = `仅支持保留${info.decimalPlaces}位小数`;
            }
            if (ques) ques.validate = true;
            info.validate = true;
            return (result = true);
        }

    }
    return result;
}
const countDecimalPlaces = (num) => {
    const match = num.toString().match(/\.(\d+)/);
    return match ? match[1].length : 0;
}